import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConfigService} from '../../service/config.service';
import {Keys, StorageService} from '../../service/storage.service';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    private readonly finzyPlatformUrls: string[];
    private readonly storageService: StorageService;

    constructor(storageService: StorageService, configService: ConfigService) {
        this.storageService = storageService;
        this.finzyPlatformUrls = [configService.baseUrl(), configService.loanApplicationServiceUrl(), configService.getEligibilityCheckServiceUrl(),
            configService.getCreditAssessmentServiceUrl(), configService.getCreditBureauServiceUrl(),ConfigService.getFileManagementServiceUrl(),
            ConfigService.getPartnerServiceUrl(), ConfigService.getInvitationServiceBaseUrl(), configService.getInvestmentServiceBaseUrl(),
            configService.getUserServiceUrl(), configService.getLoanServiceUrl(), configService.getPaymentCollectionServiceUrl(),configService.getUserService_V2_Url(), configService.getLoanService_V2_Url(),
            configService.getAccountServiceUrl(), configService.getCreditBureauServiceBaseUrl()];
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.finzyPlatformUrls.some(url => request.url.startsWith(url))) {
            const authToken = this.storageService.getItem(Keys.TOKEN);
            if (authToken) {
                const profileId = this.storageService.getItem(Keys.PROFILE_ID);
                const params = (request.url.startsWith(ConfigService.getFileManagementServiceUrl())) ?
                    {'userId': profileId} : {'profile_id': profileId};
                request = request.clone({
                    setHeaders: {
                        'x-access-token': authToken,
                        'Authorization': `Bearer ${authToken}`
                    },
                    setParams: params
                });
            }
        }

        return next.handle(request);
    }
}
